(function () {
  const relatedSwipers = new WeakMap();
  const DESKTOP_BREAKPOINT = 748;

  function destroyRelatedSwipers(root) {
    const containers = root.querySelectorAll('[data-wondr-seo-blog-related-swiper]');

    for (const container of containers) {
      const instance = relatedSwipers.get(container);

      if (instance) {
        instance.destroy(true, true);
        relatedSwipers.delete(container);
      }
    }
  }

  function initRelatedSwipers(root) {
    if (typeof Swiper === 'undefined') return;

    const containers = root.querySelectorAll('[data-wondr-seo-blog-related-swiper]');

    for (const container of containers) {
      const slides = container.querySelectorAll('.swiper-slide');
      const paginationEl = container
        .closest('.wondr-seo-blog-related__carousel')
        ?.querySelector('[data-wondr-seo-blog-related-pagination]');

      if (slides.length <= 1) continue;

      const instance = new Swiper(container, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              type: 'bullets',
            }
          : false,
        breakpoints: {
          [DESKTOP_BREAKPOINT]: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 21,
          },
        },
      });

      relatedSwipers.set(container, instance);
    }
  }

  function initSection(section) {
    destroyRelatedSwipers(section);
    initRelatedSwipers(section);
  }

  function initAll() {
    const sections = document.querySelectorAll('[data-wondr-seo-blog-related]');

    for (const section of sections) {
      initSection(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-wondr-seo-blog-related]');

    if (section) {
      initSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector?.('[data-wondr-seo-blog-related]');

    if (section) {
      destroyRelatedSwipers(section);
    }
  });
})();
